module.exports = __webpack_public_path__ + "img/30m.d90d2842.png";